import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ eyebrow, title, tagline, children }) {
  return (
    <div className="min-h-screen bg-[#FCFCFA] flex flex-col">
      <header className="border-b border-[#E3DED2]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center"><Logo variant="dark" className="h-9" /></Link>
          <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 sc-label text-[#6E5F58] hover:text-[#48020C]"><ArrowLeft className="w-4 h-4" /> Início</Link>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 sm:px-10 py-16 lg:py-24 w-full">
        {eyebrow && <div className="sc-label text-[#48020C]">{eyebrow}</div>}
        <h1 className="font-serif text-4xl sm:text-5xl text-[#26130E] mt-4 leading-tight">{title}</h1>
        {tagline && <p className="font-serif text-2xl text-[#48020C] mt-4">{tagline}</p>}
        <div className="mt-10 space-y-6 text-[#3A1F19] leading-relaxed">{children}</div>
      </main>

      <Footer />
    </div>
  );
}

export function Clause({ n, title, children }) {
  return (
    <section className="border-t border-[#E3DED2] pt-6">
      <h2 className="font-serif text-2xl text-[#48020C]">{n ? `${n}. ` : ""}{title}</h2>
      <div className="mt-3 space-y-3">{children}</div>
    </section>
  );
}
